import $ from 'jquery';

var $wizardHorseForm = $('#wizardSelectHorseForm'),
    $wizardHorseSelect = $wizardHorseForm.find('#horse_name_sel'),
    $wizardHorseError = $wizardHorseForm.find('#horseSelectedError');

function showError(shouldShow) {
    $wizardHorseError[shouldShow ? 'removeClass' : 'addClass']('jsHide');
}

function isHorseSelected() {
    return $wizardHorseSelect.val() !== '';
}

$wizardHorseSelect.on('change', function() {
    showError(!isHorseSelected());
});

$wizardHorseForm.on('submit', function(e) {
    var isNotValid = !isHorseSelected();

    if (isNotValid) {
        e.preventDefault();
        showError(isNotValid);
    }
});
